import request from '@/utils/request'
import qs from 'qs'
export function getBreakfastReportList(query) {
  return request({
    url: '/report-service/v1/breakfast-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getBreakfastReportExcel(query) {
  return request({
    url: '/report-service/v1/breakfast-report/listExcel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
